import React, { useEffect, useState } from "react";

function TreeCounter({ paidTrees, totalTrees, goal }) {
  const [animatedWidth, setAnimatedWidth] = useState(0);
  const percentage = goal > 0 ? Math.min((totalTrees / goal) * 100, 100) : 0;
  const pledgedTrees = totalTrees - paidTrees;

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedWidth(percentage);
    }, 100);
    return () => clearTimeout(timer);
  }, [percentage]);

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 max-w-2xl mx-auto">
      <div className="text-center mb-4">
        <p className="text-lg font-semibold text-sritaru-800">
          &#127795; {paidTrees.toLocaleString()} trees planted
          {pledgedTrees > 0 && (
            <span className="text-earth-500">
              {" "}
              | {pledgedTrees.toLocaleString()} trees pledged
            </span>
          )}
        </p>
        <p className="text-sm text-gray-500">
          Goal: {goal.toLocaleString()} trees
        </p>
      </div>

      {/* Progress bar */}
      <div className="w-full bg-sritaru-100 rounded-full h-6 overflow-hidden relative">
        <div
          className="h-full bg-gradient-to-r from-sritaru-500 to-sritaru-600 rounded-full transition-all duration-1000 ease-out"
          style={{ width: `${animatedWidth}%` }}
        />
        <span className="absolute inset-0 flex items-center justify-center text-xs font-bold text-sritaru-900">
          {percentage.toFixed(1)}%
        </span>
      </div>

      <p className="text-center text-sm text-gray-400 mt-2">
        {totalTrees.toLocaleString()} / {goal.toLocaleString()} total trees
        (including pledges)
      </p>
    </div>
  );
}

export default TreeCounter;
